import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface ApplicationConfiguredSetting {
  categoryId: string;
  bundleIdentifier: string;
  displayName: string | null;
  adamIdStr: string | null;
}

export type ApplicationsConfiguredSettingsState = EntityState<ApplicationConfiguredSetting>;

export function selectId(application: ApplicationConfiguredSetting) {
  return `${application.categoryId}-${application.bundleIdentifier}`;
}

export const adapter: EntityAdapter<ApplicationConfiguredSetting> = createEntityAdapter<ApplicationConfiguredSetting>({
  selectId,
});

export const initialState: ApplicationsConfiguredSettingsState = adapter.getInitialState();
